module.exports = __webpack_public_path__ + "static/media/entry-page.35db8977.jpg";